import { label as labelCls, input as inputCls } from '../lib/ui';

// Thin wrappers that give every signed-in form the same fields, focus ring and dark mode.
export function Field({ label, htmlFor, hint, className = '', children }) {
  return (
    <div className={className}>
      {label && <label htmlFor={htmlFor} className={labelCls}>{label}</label>}
      {children}
      {hint && <p className="mt-1.5 text-sm text-slate-500 dark:text-slate-400">{hint}</p>}
    </div>
  );
}

export function Input({ className = '', ...props }) {
  return <input {...props} className={`${inputCls} ${className}`} />;
}

export function Select({ className = '', children, ...props }) {
  return <select {...props} className={`${inputCls} pr-10 ${className}`}>{children}</select>;
}

export function Textarea({ className = '', ...props }) {
  return <textarea {...props} className={`${inputCls} min-h-[96px] py-3 ${className}`} />;
}

export function Checkbox({ className = '', ...props }) {
  return (
    <input
      type="checkbox"
      {...props}
      className={`h-5 w-5 rounded border-slate-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-customBlue focus:ring-customBlue ${className}`}
    />
  );
}
